export const deliriumData = [
    {
        category: 'Alertness',
        text: 'This includes patients who may be markedly drowsy (eg. difficult to rouse and/or obviously sleepy ' +
            'during assessment) or agitated/hyperactive. Observe the patient. If asleep, attempt to wake with ' +
            'speech or gentle touch on shoulder. Ask the patient to state their name and address to assist rating.',
        values: [
            {
                text: 'Normal (fully alert, but not agitated, throughout assessment)',
                score: 0,
            },
            {
                text: 'Mild sleepiness for <10 seconds after waking, then normal',
                score: 0,
            },
            {
                text: 'Clearly abnormal',
                score: 4,
            },
        ],
    },
    {
        category: 'AMT4',
        text: 'Age, date of birth, place (name of the hospital or building), current year.',
        values: [
            {
                text: 'No mistakes',
                score: 0,
            },
            {
                text: '1 mistake',
                score: 1,
            },
            {
                text: '2 or more mistakes/untestable',
                score: 2,
            },
        ],
    },
    {
        category: 'Attention',
        text: 'Ask the patient: “Please tell me the months of the year in backwards order, starting at December.” ' +
            'To assist initial understanding one prompt of “what is the month before December?” is permitted.',
        values: [
            {
                text: 'Achieves 7 months or more correctly',
                score: 0,
            },
            {
                text: 'Starts but scores <7 months / refuses to start',
                score: 1,
            },
            {
                text: 'Untestable (cannot start because unwell, drowsy, inattentive)',
                score: 2,
            },
        ],
    },
    {
        category: 'Acute Change or Fluctuating Course',
        text: 'Evidence of significant change or fluctuation in: alertness, cognition, other mental function ' +
            '(eg. paranoia, hallucinations) arising over the last 2 weeks and still evident in last 24hrs',
        values: [
            {
                text: 'No',
                score: 0,
            },
            {
                text: 'Yes',
                score: 4,
            },
        ],
    },
];
